import React, { FC } from 'react'

import { t, Trans } from '@lingui/macro'

import {
  ButtonType,
  LinkButton
} from 'components/buttons/LinkButton/LinkButton'

import styles from './NoBroadcastLabel.module.scss'

interface NoBroadcastLabelProps {
  id?: string
  channelSlug?: string
}

export const NoBroadcastLabel: FC<NoBroadcastLabelProps> = ({
  id,
  channelSlug
}) => {
  if (!id || !channelSlug) {
    return (
      <div className={styles.NoBroadcastLabel}>
        <Trans>No broadcast</Trans>
      </div>
    )
  }
  return (
    <LinkButton
      type={ButtonType.Secondary}
      buttonSize="Small"
      label={t`No broadcast`}
      link={`/${channelSlug}/games/g/${id}`}
    />
  )
}
